import React from 'react';
import EventCard from './event-card';

export default function EventsGrid({ events, onTypeFilter, selectedType }) {
  /* const eventTypes = [
    { id: null, name: 'Todos' },
    { id: 1, name: 'Musical' },
    { id: 2, name: 'Deportes' },
    { id: 3, name: 'Teatro' },
    { id: 4, name: 'Cine' },
  ]; */

  return (
    <section className="container py-5">
      {/* Type filters */}
      {/*  <div className="d-flex gap-3 mb-5 pb-4 border-bottom overflow-x-auto">
        {eventTypes.map((type) => (
          <button
            key={type.id}
            onClick={() => onTypeFilter(type.id)}
            className={
              selectedType === type.id
                ? 'btn btn-link text-primary-custom text-decoration-none fw-semibold border-bottom border-primary-custom'
                : 'btn btn-link text-secondary text-decoration-none fw-semibold'
            }
            style={{
              whiteSpace: 'nowrap',
              padding: '8px 0',
              borderBottomWidth: selectedType === type.id ? '2px' : '0',
            }}
          >
            {type.name}
          </button>
        ))}
      </div> */}

      {/* Events grid */}
      {events.length === 0 ? (
        <div className="text-center py-5">
          <i className="fas fa-search" style={{ fontSize: '48px', color: '#d1d5db', marginBottom: '16px', display: 'block' }}></i>
          <p className="text-secondary">No se encontraron eventos</p>
        </div>
      ) : (
        <div className="row g-4">
          {events.map((event) => (
            <div key={event.id_event} className="col-12 col-md-6 col-lg-4">
              <EventCard event={event} />
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
